export enum Vraagtype {
  OpenOptioneel = 'OPEN_0',
  Open = 'OPEN_1',
  OpenN = 'OPEN_N',
  Foto = 'FOTO_004',
  Upload = 'UPLOAD',
  MultiUpload = 'MULTI_UPLOAD',
  Gesloten_1 = 'GESLOTEN_1',
  Gesloten_N = 'GESLOTEN_N',
  Versturen = 'VRAGENBOOM_VERSTUREN',
  Telefoon = 'TELEFONISCH_MELDEN',
  NaarSchadetail = 'NAAR_DETAILS',
  EindeProcesSucces = 'VRAGENBOOM_EINDE_PROCES_SUCCES',
  EindeProcesEmail = 'VRAGENBOOM_EINDE_PROCES_EMAIL',
  EindeProcesNietGedekt = 'VRAGENBOOM_EINDE_PROCES_NIET_GEDEKT',
  OnlineNietMogelijk = 'FAILURE_2',
  VerzekeringNietAfgesloten = 'FAILURE_3',
  AndersMelden = 'FAILURE_4', // wordt gebruikt voor zakelijk schademelden
  GeenDekkingRuit = 'FAILURE_5',
  Info1 = 'INFO_001',
  Label1 = 'LABEL_001',
  Label2 = 'LABEL_002',
  Label3 = 'LABEL_003',
  Label4 = 'LABEL_004',
  Label5 = 'LABEL_005',
  LabelProgress = 'LABEL_006',
  LabelBedankt = 'LABEL_007',
  Label8 = 'LABEL_008',
  Label10 = 'LABEL_010', // wordt gebruikt voor zakelijk schademelden  
  LabelLijst = 'LABEL_020',
  LabelUitleg = 'LABEL_021',
  LabelBedrag = 'LABEL_022',
  LabelGrijs = 'LABEL_GRIJS',
  LabelVisite = 'LABEL_VISITE',
  LabelBreak = 'LABEL_BREAK',
  LabelBmGevolgen = 'LABEL_BMGEVOLGEN',
  LabelBmGrijs = 'LABEL_BMGRIJS',
  LabelOpsomming = 'LABEL_OPSOMMING'
}
